import { controls } from "../../controls";

const rp607 = {
  label: "CCB 12-Part B-Non Agri",
  pageLabel: "CCB 12-Part B-Non Agri",
  starting: true,
  url: "rp607",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({tab: "filter",label: "As on Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"as_on_date",width:"col-sm-2"}),
        
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-3 "}),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter'}),
  ],

  
  form:[],

  history: {
    perPage: 10,
    reportHeader: "STATEMENT CCB-12\nB. Total position of defaults by Borrowing",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    displayColumns: [
      {
        Header: "Type of loan defaulted (including Cash Credit)",
        accessor: "loan_type"
      },
      
      {
        Header: "No. of accounts",
        accessor: "no_acct",
        width: 200
      },  
      
      {
        Header: "Amount",
        accessor: "amt",
        type:"currency",
        width: 200
      }
    ]
  }
};

export default rp607;